import React from 'react';
import { withTranslation, Trans } from 'react-i18next';
import { Alert, Modal, ModalBody, UncontrolledDropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import Button from './button';
import { getPreassignRoomAvailability, preassignRoom } from "../models/reservation";
import i18n from '../i18n';
class PreassignRoom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadedRooms: false,
      isAssigningRoom: false,
      selectedAssignRoom:null,
      rooms: null,
      assignConfirmation:null,
      assignError: null
    };
  }
  componentDidMount() {
  }
  componentDidUpdate(prevProps) {
    if(prevProps.open !== this.props.open && this.props.open){
      let res = this.props.reservation;
      getPreassignRoomAvailability(res.reservationId)
      .then(
        result => {
          this.setState({
            isLoadedRooms: true,
            rooms: result,
          });
        },
        error => {
          this.setState({
            isLoadedRooms: true,
            error
          });
        }
      );
    }
  }
  
  preAssignRoom(room){
    this.setState({isAssigningRoom:true})
    preassignRoom(this.props.reservation.reservationId,room)
      .then(result => {
        if(this.props.handleUpdateReservation){
          this.props.handleUpdateReservation(result);
        }
        this.setState({
          isAssigningRoom:false,
          selectedAssignRoom:null,
        }, () => setTimeout(()=>this.setState({assignConfirmation:null}),15000))
      }, error => {
        this.setState({
          assignError:error,
          isAssigningRoom:false });
    });
  }
  render() {
    const { t, reservation } = this.props;
    const { assignError, selectedAssignRoom, isAssigningRoom, assignConfirmation, rooms } = this.state;
    const currentAssignedRoomUnavailable = reservation.roomIdPreassign&&rooms&&!rooms.find(room => room.id===reservation.roomIdPreassign).available;
    return <Modal isOpen={this.props.open} toggle={this.props.toggle} centered={true} className={"lang-" + i18n.language} modalClassName="modal-place-user">
    <div className="modal-header">
    {t("Preassign User to Room")}
      <button type="button" onClick={this.props.toggle} className="close" aria-label="Close"><span aria-hidden="true">×</span></button>
    </div>
    <ModalBody>
      {assignError?<Alert color="warning">{t(assignError)}</Alert>:null}
      {currentAssignedRoomUnavailable?<Alert color="warning">{t("Currently preassigned room is unavailable.")}</Alert>:null}
      {assignConfirmation?<Alert color="success">{t(assignConfirmation)}</Alert>:null}
      <div className="text-start">
      {reservation.roomIdPreassign?
        <div className="mb-2"><Trans i18nKey="userCurrentlyPreassigned">User is currently preassigned to room {{preassignedId: reservation.roomIdPreassign}}</Trans></div>
      :null}
      <UncontrolledDropdown>
        <DropdownToggle caret>{selectedAssignRoom?selectedAssignRoom.id:reservation.roomIdPreassign?reservation.roomIdPreassign:t('Rooms')}</DropdownToggle>
        <DropdownMenu>
          {rooms && rooms.map((room,i)=>
            (!reservation.bath || reservation.bath == room.bath)?
            <DropdownItem className={selectedAssignRoom && selectedAssignRoom.id==room.id?'active':!selectedAssignRoom && room.id==reservation.roomIdPreassign?'active':''} onClick={()=>this.setState({selectedAssignRoom: {id: room.id}})} key={i}>{room.id}{room.available?'':' - ' + t("Unavailable")}</DropdownItem>
            :null
          )}
        </DropdownMenu>
      </UncontrolledDropdown>
      <div className="d-flex justify-content-end">
      {reservation.roomIdPreassign?
        <Button className="btn btn-secondary mie-3" loading={isAssigningRoom} onClick={() => this.preAssignRoom(0)}>{t("Remove Preassigned Room")}</Button>
      :null}
        <Button className="btn btn-secondary" disabled={selectedAssignRoom && (selectedAssignRoom.id !== reservation.roomIdPreassign)?false:true} loading={isAssigningRoom} onClick={() => this.preAssignRoom(selectedAssignRoom.id)}>{t("Confirm")}</Button>
      </div>
      </div>
    </ModalBody>
  </Modal>
  }
}
export default withTranslation()(PreassignRoom);